import { Component, Input, OnInit, Renderer2, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { GenericFormGroupComponent } from '../../../forms/generic-form-group.component';
import { Student } from '../../../shared/interface/roster.interface';
import { GradeStatement, GradeStatementOption } from '../../../shared/interface/grade-statement.interface';
import {GradeStatementScenarioType} from "../../../shared/enum/grade-statement-scenario-type";

@Component({
    selector: 'app-roster-grade-statement-content',
    templateUrl: './grade-statement-content.component.html',
    styleUrls: ['./grade-statement-content.component.scss'],
    encapsulation: ViewEncapsulation.Emulated
})
export class GradeStatementContentComponent extends GenericFormGroupComponent implements OnInit {
    constructor(protected renderer2: Renderer2) {
        super(renderer2);
    }

    showSelect: boolean;

    gradeStatementOptions: GradeStatementOption[];
    readonly gradeStatementScenarioType: GradeStatementScenarioType = GradeStatementScenarioType.getInstance();

    @Input() gradeStatement: GradeStatement;
    @Input() student: Student;

    ngOnInit(): void {
        console.log(this.gradeStatement);
        console.log(this.student);

        this.gradeStatementOptions = this.gradeStatement.gradeStatementText.gradeStatementOption.sort(
            function compareFn(a: GradeStatementOption, b: GradeStatementOption) {
                return a.sortOrder - b.sortOrder;
            }
        );
        // find which statement to display
        if (
            this.gradeStatement.gradeStatementText.gradeStatementOption.find(
                (item: GradeStatementOption) => item.displayAsOption === true
            )
        ) {
            this.showSelect = true;
        } else {
            // not show selected. default id response
            //note: this is for GD grading which does not have a drop down.
            this.showSelect = false;

            this.student.gradeResponse.gradeStatementOptionId =
                this.gradeStatement.gradeStatementText.gradeStatementOption[0].id;
        }
    }
}
